import { IAcompanhamentoStrategy } from "./IAcompanhamentoStrategy.js";
import { listarEmpresasDoConsultor } from "../empresaAcompanhamentoService.js";
import { criarLogger } from "../acompanhamentoHelpers.js";

const logConsultor = criarLogger("Strategy:Consultor");

/**
 * Estratégia especializada para o perfil Consultor Externo.
 *
 * Princípio da Responsabilidade Única (SRP):
 * Carrega exclusivamente as empresas cadastradas pelo consultor logado.
 */
export class ConsultorAcompanhamentoStrategy extends IAcompanhamentoStrategy {
  async carregar({ token, identidade = {} } = {}) {
    logConsultor("Carregando empresas do consultor...");
    const lista = await listarEmpresasDoConsultor({
      token,
      usuarioIdLogado: identidade.usuarioId,
      documentoLogado: identidade.documento,
    });
    logConsultor("Empresas retornadas para o consultor:", lista.length);
    return lista;
  }
}
